import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

function changeBackgroundColor() {
    gsap.to('.transparent-navbar', {
        backgroundColor: '#354340',
        scrollTrigger: {
            start: 0,
            end: 100,
            scrub: true,
        },
    });
}

function changeNavLinksOnScroll() {
    gsap.to('.nav-link', {

        scrollTrigger: {
            start: 0,
            end: 100,
            scrub: true,
        },
    });
}

export default function initNavScroll() {
    gsap.registerPlugin(ScrollTrigger);

    changeBackgroundColor();
    changeNavLinksOnScroll();
}
